import {isEmpty, take as takeLodash} from 'lodash';
import {
	fetchCommonLadderFailed,
	fetchCommonLadderSuccess,
	fetchContestByStateLadderFailed,
	fetchContestByStateLadderNoSpread,
	fetchContestByStateLadderSuccess,
	fetchContestByStoreLadderFailed,
	fetchContestByStoreLadderNoSpread,
	fetchContestByStoreLadderSuccess,
	fetchContestLadderFailed,
	fetchContestLadderNoSpread,
	fetchContestLadderSuccess,
	fetchContestsSuccess,
	fetchLadderPending,
	fetchMonthByStateLadderNoSpread,
	fetchMonthByStateLadderSuccess,
	fetchMonthByStoreLadderNoSpread,
	fetchMonthByStoreLadderSuccess,
	fetchMonthLadderNoSpread,
	fetchMonthLadderSuccess,
	fetchOverallByStateLadderFailed,
	fetchOverallByStateLadderNoSpread,
	fetchOverallByStateLadderSuccess,
	fetchOverallByStoreLadderFailed,
	fetchOverallByStoreLadderNoSpread,
	fetchOverallByStoreLadderSuccess,
	fetchOverallLadderFailed,
	fetchOverallLadderNoSpread,
	fetchOverallLadderSuccess,
	fetchRoundLadderFailed,
	fetchRoundLadderNoSpread,
	fetchRoundLadderSuccess,
	fetchRoundStateLadderFailed,
	fetchRoundStateLadderNoSpread,
	fetchRoundStateLadderSuccess,
	fetchRoundStoreLadderFailed,
	fetchRoundStoreLadderNoSpread,
	fetchRoundStoreLadderSuccess,
	fetchTeamCommonLadderFailed,
	fetchTeamCommonLadderSuccess,
	fetchTeamContestLadderFailed,
	fetchTeamContestLadderNoSpread,
	fetchTeamContestLadderSuccess,
	fetchTeamContestStateLadderFailed,
	fetchTeamContestStateLadderNoSpread,
	fetchTeamContestStateLadderSuccess,
	fetchTeamContestStoreLadderFailed,
	fetchTeamContestStoreLadderNoSpread,
	fetchTeamContestStoreLadderSuccess,
	fetchTeamMonthByStateLadderFailed,
	fetchTeamMonthByStateLadderNoSpread,
	fetchTeamMonthByStateLadderSuccess,
	fetchTeamMonthByStoreLadderFailed,
	fetchTeamMonthByStoreLadderNoSpread,
	fetchTeamMonthByStoreLadderSuccess,
	fetchTeamMonthLadderFailed,
	fetchTeamMonthLadderNoSpread,
	fetchTeamMonthLadderSuccess, fetchTeamSeasonLadderFailed,
	fetchTeamSeasonLadderNoSpread,
	fetchTeamSeasonLadderSuccess,
	globalError,
} from "modules/actions";

import {
	getLastCompletedRound,
	getLastGameContest,
	getRegionSelector,
	getTriviaContests,
	getUserStoreObject
} from 'modules/selectors';

import {
	ICommonOptions,
	ILadderAPIOptions,
	IMonthLadderAPIOptions,
	IQueryParams,
	IRoundAPIOptions,
	ISagaAction
} from "modules/types";

import {ApiError, EnumTriviaLadders, getMonthAndYearOfDateForAPI, TriviaApi} from "modules/utils";
import {SagaIterator} from "redux-saga";
import {call, put, select, take} from "typed-redux-saga";


const defaultWebOptions: IQueryParams = {
	limit    : 25,
	offset   : 0,
};

export const fetchOverallLadderSaga = function* (action: ISagaAction<ILadderAPIOptions>) {
	yield put(fetchLadderPending());

	try {

		const options = action.payload || {};
		const region  = yield* select(getRegionSelector);
		const result = yield* call(TriviaApi.leaderboards.overall, {
			region,
			...defaultWebOptions,
			...options
		});

		ApiError.CHECK(result);

		yield put(fetchOverallLadderSuccess(result.result));

	} catch (e: any) {
		const error = e as Error;
yield put(globalError(error))
		yield put(fetchOverallLadderFailed());

	}
};

export const fetchOverallStateLadderSaga = function* (action: ISagaAction<ILadderAPIOptions>) {
	yield put(fetchLadderPending());
	const store = yield* select(getUserStoreObject);
	try {

		const options = action.payload || {};
		const region  = yield* select(getRegionSelector);

		const result = yield* call(TriviaApi.leaderboards.overall_state, {
			region,
			state_id: store?.state_id,
			...defaultWebOptions,
			...options
		});

		ApiError.CHECK(result);

		yield put(fetchOverallByStateLadderSuccess(result.result));

	} catch (e: any) {
		yield put(globalError(e))
		yield put(fetchOverallByStateLadderFailed());

	}
};

export const fetchOverallStoreLadderSaga = function* (action: ISagaAction<ILadderAPIOptions>) {
	yield put(fetchLadderPending());
	const store = yield* select(getUserStoreObject);
	try {

		const options = action.payload || {};
		const region  = yield *select(getRegionSelector);
		const result = yield* call(TriviaApi.leaderboards.overall_state, {
			region,
			store_id: store?.id,
			...defaultWebOptions,
			...options
		});

		ApiError.CHECK(result);

		yield put(fetchOverallByStoreLadderSuccess(result.result));

	} catch (e: any) {
		const error = e as Error;
		yield put(globalError(error))
		yield put(fetchOverallByStoreLadderFailed());
	}
};

export const fetchMonthLadderSaga = function* (action: ISagaAction<IMonthLadderAPIOptions>) {
	yield put(fetchLadderPending());

	try {
		const last_completed_contest = yield* select(getLastGameContest);
		const month = action.payload.month || last_completed_contest?.start_date_time;
		const date = getMonthAndYearOfDateForAPI(month);

		const options = action.payload || {};
		const region = yield* select(getRegionSelector);
		const result = yield* call(TriviaApi.leaderboards.month, {
			region,
			...defaultWebOptions,
			...options,
			month: date,
		});

		ApiError.CHECK(result);

		yield put(fetchMonthLadderSuccess(result.result));

	} catch (e: any) {
		yield put(globalError(e))
	}
};

export const fetchMonthByStateLadderSaga = function* (action: ISagaAction<IMonthLadderAPIOptions>) {
	yield put(fetchLadderPending());

	try {
		const last_completed_contest = yield* select(getLastGameContest);
		const month = action.payload.month || last_completed_contest?.start_date_time;
		const date = getMonthAndYearOfDateForAPI(month);

		const store = yield* select(getUserStoreObject);
		const options = action.payload || {};

		const result = yield* call(TriviaApi.leaderboards.month_state, {
			...defaultWebOptions,
			...options,
			state_id: store?.state_id,
			month: date,
		});

		ApiError.CHECK(result);

		yield put(fetchMonthByStateLadderSuccess(result.result));

	} catch (e: any) {
		const error = e as Error;
		yield put(globalError(error))
	}
};

export const fetchMonthByStoreLadderSaga = function* (action: ISagaAction<IMonthLadderAPIOptions>) {
	yield put(fetchLadderPending());

	try {
		const last_completed_contest = yield* select(getLastGameContest);
		const month = action.payload.month || last_completed_contest?.start_date_time;
		const date = getMonthAndYearOfDateForAPI(month);
		const options = action.payload || {};
		const store = yield* select(getUserStoreObject);

		const result = yield* call(TriviaApi.leaderboards.month_store, {
			store_id: store?.id,
			...defaultWebOptions,
			...options,
			month: date,
		});

		ApiError.CHECK(result);

		yield* put(fetchMonthByStoreLadderSuccess(result.result));

	} catch (e: any) {
		yield put(globalError(e))
	}
};

export const fetchRoundLadderSaga = function* (action: ISagaAction<Partial<IRoundAPIOptions>>) {
	yield put(fetchLadderPending());

	try {
		const last_completed_round = yield* select(getLastCompletedRound);
		const options = action.payload || {};

		if (!last_completed_round) {
			return;
		}

		const result = yield* call(TriviaApi.leaderboards.round, {
			round_id: last_completed_round.id,
			...defaultWebOptions,
			...options
		});

		ApiError.CHECK(result);

		yield put(fetchRoundLadderSuccess(result.result));

	} catch (e: any) {
		console.log(e);
		yield put(fetchRoundLadderFailed());
		yield put(globalError(e))
	}
};

export const fetchRoundStoreLadderSaga = function* (action: ISagaAction<Partial<IRoundAPIOptions>>) {
	yield put(fetchLadderPending());

	try {
		const last_completed_round = yield* select(getLastCompletedRound);
		const options = action.payload || {};
		const store = yield* select(getUserStoreObject);
		if (!last_completed_round) {
			return;
		}

		const result = yield* call(TriviaApi.leaderboards.round_by_store, {
			round_id: last_completed_round.id,
			store_id: store?.id,
			...defaultWebOptions,
			...options,
		});

		ApiError.CHECK(result);

		yield put(fetchRoundStoreLadderSuccess(result.result));

	} catch (e: any) {
		console.log(e);
		yield put(fetchRoundStoreLadderFailed());
		yield put(globalError(e))
	}
};

export const fetchRoundStateLadderSaga = function* (action: ISagaAction<Partial<IRoundAPIOptions>>) {
	yield put(fetchLadderPending());

	try {
		const last_completed_round = yield* select(getLastCompletedRound);
		const options = action.payload || {};
		const store = yield* select(getUserStoreObject);
		if (!last_completed_round) {
			return;
		}

		const result = yield* call(TriviaApi.leaderboards.round_by_state, {
			round_id: last_completed_round.id,
			state_id: store?.state_id,
			...defaultWebOptions,
			...options,
		});

		ApiError.CHECK(result);

		yield put(fetchRoundStateLadderSuccess(result.result));

	} catch (e: any) {
		console.log(e);
		yield put(fetchRoundStateLadderFailed());
		yield put(globalError(e))
	}
};

export const fetchContestByStoreLadderSaga = function* (action: ISagaAction<ILadderAPIOptions>) {
	yield put(fetchLadderPending());

	try {
		const options = action.payload || {};
		const contest = yield* select(getLastGameContest);
		const store = yield* select(getUserStoreObject);

		const apiParams: ILadderAPIOptions = {
			contest_id: contest?.id,
			store_id: store?.id ,
			...defaultWebOptions,
			...options
		};

		const result = yield* call(TriviaApi.leaderboards.contest_by_store, apiParams);

		ApiError.CHECK(result);

		yield put(fetchContestByStoreLadderSuccess(result.result));

	} catch (e: any) {
		console.log(e);
		yield put(fetchContestByStoreLadderFailed());
		yield put(globalError(e))
	}
};

export const fetchContestByStateLadderSaga = function* (action: ISagaAction<ILadderAPIOptions>) {
	yield put(fetchLadderPending());

	try {

		const options = action.payload || {};
		const contest = yield* select(getLastGameContest);
		const store = yield* select(getUserStoreObject);

		const apiParams: ILadderAPIOptions = {
			contest_id: contest?.id,
			state_id: store?.state_id ,
			...defaultWebOptions,
			...options
		};

		const result = yield* call(TriviaApi.leaderboards.contest_by_state, apiParams);

		ApiError.CHECK(result);

		yield put(fetchContestByStateLadderSuccess(result.result));

	} catch (e: any) {
		console.log(e);
		yield put(fetchContestByStateLadderFailed());
		yield put(globalError(e))
	}
};

export const fetchContestLadderSaga = function* (action: ISagaAction<ILadderAPIOptions>) {
	yield put(fetchLadderPending());
	const contests = yield* select(getTriviaContests);

	if(isEmpty(contests)) {
		yield take(fetchContestsSuccess)
	}

	try {
		const options = action.payload || {};
		const contest = yield* select(getLastGameContest);

		const apiParams: ILadderAPIOptions = {
			contest_id: contest?.id,
			...defaultWebOptions,
			...options
		};

		const result = yield* call(TriviaApi.leaderboards.contest, apiParams);

		ApiError.CHECK(result);

		yield put(fetchContestLadderSuccess(result.result));


	} catch (e: any) {
		console.log(e);
		yield put(fetchContestLadderFailed());
		yield put(globalError(e))
	}
};

export const fetchCommonLadderSaga = function* (action: ISagaAction<Partial<ILadderAPIOptions>>) {
	yield put(fetchLadderPending());
	const store = yield* select(getUserStoreObject);
	const options = action.payload;

	try {
		const contest = yield* select(getLastGameContest);

		const apiParams: ILadderAPIOptions = {
			contest_id: contest?.id,
			state_id:  store?.state_id,
			store_id:  store?.id,
			...defaultWebOptions,
			...options
		};

		const result = yield* call(TriviaApi.leaderboards.common, apiParams);

		ApiError.CHECK(result);

		let ladders = {};

		if ( isEmpty(result.result) ) {
			ApiError.THROW_ERROR(`Empty response from BE for - contest ID${apiParams.contest_id}`);
		}

		for ( const item of Object.keys(result.result) ) {
			const ladder_item = result.result[ item ];
			ladders = {
				...ladders,
				[ item ]: {
					items     : ladder_item,
					podium    : takeLodash(ladder_item, 3),
					is_fetched: true
				}
			};
		}


		yield put(fetchCommonLadderSuccess(ladders));


	} catch (e: any) {
		console.log(e);
		yield put(fetchCommonLadderFailed());
		yield put(globalError(e))
	}
};

const ladderSagaActions = {
	[ EnumTriviaLadders.contest ]         : fetchContestLadderNoSpread,
	[ EnumTriviaLadders.contest_by_state ]: fetchContestByStateLadderNoSpread,
	[ EnumTriviaLadders.contest_by_store ]: fetchContestByStoreLadderNoSpread,
	[ EnumTriviaLadders.month ]: fetchMonthLadderNoSpread,
	[ EnumTriviaLadders.month_by_state ]: fetchMonthByStateLadderNoSpread,
	[ EnumTriviaLadders.month_by_store ]: fetchMonthByStoreLadderNoSpread,
	[ EnumTriviaLadders.round ]: fetchRoundLadderNoSpread,
	[ EnumTriviaLadders.round_by_state ]: fetchRoundStateLadderNoSpread,
	[ EnumTriviaLadders.round_by_store ]: fetchRoundStoreLadderNoSpread,
	[ EnumTriviaLadders.overall ]: fetchOverallLadderNoSpread,
	[ EnumTriviaLadders.overall_by_state ]: fetchOverallByStateLadderNoSpread,
	[ EnumTriviaLadders.overall_by_store ]: fetchOverallByStoreLadderNoSpread,


	[ EnumTriviaLadders.team_season ]: fetchTeamSeasonLadderNoSpread,
	[ EnumTriviaLadders.team_season_state ]: fetchTeamSeasonLadderNoSpread,
	[ EnumTriviaLadders.team_season_store ]: fetchTeamSeasonLadderNoSpread,

	[ EnumTriviaLadders.team_month ]: fetchTeamMonthLadderNoSpread,
	[ EnumTriviaLadders.team_month_by_state ]: fetchTeamMonthByStateLadderNoSpread,
	[ EnumTriviaLadders.team_month_by_store ]: fetchTeamMonthByStoreLadderNoSpread,

	[ EnumTriviaLadders.team_contest ]: fetchTeamContestLadderNoSpread,
	[ EnumTriviaLadders.team_contest_by_state ]: fetchTeamContestStateLadderNoSpread,
	[ EnumTriviaLadders.team_contest_by_store ]: fetchTeamContestStoreLadderNoSpread,

	[ EnumTriviaLadders.team_round ]: fetchOverallLadderNoSpread,
	[ EnumTriviaLadders.team_round_by_store ]: fetchOverallByStateLadderNoSpread,
	[ EnumTriviaLadders.team_round_by_state ]: fetchOverallByStoreLadderNoSpread,
};

export const fetchLadderSaga = function* (action: ISagaAction<ICommonOptions>): SagaIterator {
	const ladder_type = action.payload.ladder_type;
	const options = action.payload.options;

	try {
		const fetchLadderActions = ladderSagaActions[ ladder_type ];

		yield* put(fetchLadderActions(options));

	} catch (e: any) {
		console.log(e);
		const error = e as Error;
yield* put(globalError(error))
	}

};

export const fetchTeamContestLadderSaga = function* (action: ISagaAction<ILadderAPIOptions>) {
	yield put(fetchLadderPending());
	const contests = yield* select(getTriviaContests);

	if ( isEmpty(contests) ) {
		yield take(fetchContestsSuccess)
	}

	try {
		const options = action.payload || {};
		const contest = yield* select(getLastGameContest);

		const apiParams: ILadderAPIOptions = {
			contest_id: contest?.id,
			...defaultWebOptions,
			...options
		};

		const result = yield* call(TriviaApi.leaderboards.team_contest, apiParams);

		ApiError.CHECK(result);

		yield put(fetchTeamContestLadderSuccess(result.result));

	} catch (e: any) {
		console.log(e);
		yield put(fetchTeamContestLadderFailed());
		yield put(globalError(e))
	}
};

export const fetchTeamContestByStoreLadderSaga = function* (action: ISagaAction<ILadderAPIOptions>) {
	yield put(fetchLadderPending());

	try {
		const options = action.payload || {};
		const contest = yield* select(getLastGameContest);
		const store = yield* select(getUserStoreObject);

		const apiParams: ILadderAPIOptions = {
			contest_id: contest?.id,
			store_id: store?.id,
			...defaultWebOptions,
			...options
		};

		const result = yield* call(TriviaApi.leaderboards.team_contest_store, apiParams);

		ApiError.CHECK(result);

		yield put(fetchTeamContestStoreLadderSuccess(result.result));

	} catch (e: any) {
		console.log(e);
		yield put(fetchTeamContestStoreLadderFailed());
		yield put(globalError(e))
	}
};

export const fetchTeamContestByStateLadderSaga = function* (action: ISagaAction<ILadderAPIOptions>) {
	yield put(fetchLadderPending());

	try {

		const options = action.payload || {};
		const contest = yield* select(getLastGameContest);
		const store = yield* select(getUserStoreObject);

		const apiParams: ILadderAPIOptions = {
			contest_id: contest?.id,
			state_id: store?.state_id,
			...defaultWebOptions,
			...options
		};

		const result = yield* call(TriviaApi.leaderboards.team_contest_state, apiParams);

		ApiError.CHECK(result);

		yield put(fetchTeamContestStateLadderSuccess(result.result));

	} catch (e: any) {
		console.log(e);
		yield put(fetchTeamContestStateLadderFailed());
		yield put(globalError(e))
	}
};

export const fetchTeamMonthLadderSaga = function* (action: ISagaAction<IMonthLadderAPIOptions>) {
	yield put(fetchLadderPending());

	try {
		const last_completed_contest = yield* select(getLastGameContest);
		const month = action.payload.month || last_completed_contest?.start_date_time;
		const date = getMonthAndYearOfDateForAPI(month);

		const options = action.payload || {};
		const region = yield* select(getRegionSelector);
		const result = yield* call(TriviaApi.leaderboards.team_month, {
			region,
			...defaultWebOptions,
			...options,
			month: date,
		});

		ApiError.CHECK(result);

		yield put(fetchTeamMonthLadderSuccess(result.result));

	} catch (e: any) {
		yield put(fetchTeamMonthLadderFailed());

		yield put(globalError(e))
	}
};

export const fetchTeamMonthByStateLadderSaga = function* (action: ISagaAction<IMonthLadderAPIOptions>) {
	yield put(fetchLadderPending());

	try {
		const last_completed_contest = yield* select(getLastGameContest);
		const month = action.payload.month || last_completed_contest?.start_date_time;
		const date = getMonthAndYearOfDateForAPI(month);

		const store = yield* select(getUserStoreObject);
		const options = action.payload || {};

		const result = yield* call(TriviaApi.leaderboards.team_month_state, {
			...defaultWebOptions,
			...options,
			state_id: store?.state_id,
			month: date,
		});

		ApiError.CHECK(result);

		yield put(fetchTeamMonthByStateLadderSuccess(result.result));

	} catch (e: any) {
		yield put(fetchTeamMonthByStateLadderFailed());
		yield put(globalError(e))
	}
};

export const fetchTeamMonthByStoreLadderSaga = function* (action: ISagaAction<IMonthLadderAPIOptions>) {
	yield put(fetchLadderPending());

	try {
		const last_completed_contest = yield* select(getLastGameContest);
		const month = action.payload.month || last_completed_contest?.start_date_time;
		const date = getMonthAndYearOfDateForAPI(month);
		const options = action.payload || {};
		const store = yield* select(getUserStoreObject);

		const result = yield* call(TriviaApi.leaderboards.team_month_store, {
			store_id: store?.id,
			...defaultWebOptions,
			...options,
			month: date,
		});

		ApiError.CHECK(result);

		yield put(fetchTeamMonthByStoreLadderSuccess(result.result));

	} catch (e: any) {
		yield put(fetchTeamMonthByStoreLadderFailed())
		yield put(globalError(e))
	}
};

export const fetchTeamSeasonLadderSaga = function* (action: ISagaAction<ILadderAPIOptions>) {
	yield put(fetchLadderPending());

	try {
		const options = action.payload || {};

		const result = yield* call(TriviaApi.leaderboards.team_season, {
			...defaultWebOptions,
			...options,
			year: String(new Date().getFullYear())
		});

		ApiError.CHECK(result);

		yield put(fetchTeamSeasonLadderSuccess(result.result));

	} catch (e: any) {
		yield put(fetchTeamSeasonLadderFailed())
		yield put(globalError(e))
	}
};

export const fetchTeamCommonLadderSaga = function* (action: ISagaAction<Partial<ILadderAPIOptions>>) {
	yield put(fetchLadderPending());
	const store = yield* select(getUserStoreObject);
	const options = action.payload;

	try {
		const contest = yield* select(getLastGameContest);

		const apiParams: ILadderAPIOptions = {
			contest_id: contest?.id,
			state_id: store?.state_id,
			store_id: store?.id,
			...defaultWebOptions,
			...options
		};

		const result = yield* call(TriviaApi.leaderboards.team_common, apiParams);

		ApiError.CHECK(result);

		let ladders = {};

		if ( isEmpty(result.result) ) {
			ApiError.THROW_ERROR(`Empty response from BE for - contest ID${apiParams.contest_id}`);
		}

		for ( const item of Object.keys(result.result) ) {
			const ladder_item = result.result[ item ];
			ladders = {
				...ladders,
				[ item ]: {
					items: ladder_item,
					podium: takeLodash(ladder_item, 3),
					is_fetched: true
				}
			};
		}


		yield put(fetchTeamCommonLadderSuccess(ladders));


	} catch (e: any) {
		console.log(e);
		yield put(fetchTeamCommonLadderFailed());
		yield put(globalError(e))
	}
};

